import React from "react";
import { Link } from "react-router-dom";
import { API } from "../lib/api";

export default function Footer() {
  return (
    <footer className="border-t border-[#E6E4E0] paper-alt-bg mt-24">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-2xl text-[#7D2E3F] tracking-[0.12em]">PRONTO ALLA VENDITA</div>
          <div className="label-uppercase mt-1">by RX CASA</div>
          <p className="text-sm text-[#5C5657] mt-4 max-w-sm leading-relaxed">
            La categoria degli immobili verificati e valorizzati prima del mercato. Non certifichiamo,
            dichiariamo. Non un audit tecnico: un piano che trasforma la realtà in valore.
          </p>
        </div>
        <div>
          <div className="label-uppercase mb-3">Navigazione</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/galleria" className="hover:text-[#7D2E3F]">Galleria</Link></li>
            <li><Link to="/agenzie" className="hover:text-[#7D2E3F]">Agenzie Partner</Link></li>
            <li><Link to="/form" className="hover:text-[#7D2E3F]">Scopri se la tua casa può entrare</Link></li>
            <li><Link to="/area-agenzie/login" data-testid="footer-agenzie-riservata" className="text-[#5C5657] hover:text-[#7D2E3F]">Area riservata Agenzie</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-uppercase mb-3">Contatti</div>
          <ul className="space-y-2 text-sm text-[#5C5657]">
            <li><a href="mailto:info@prontoallavendita.it" className="hover:text-[#7D2E3F]">info@prontoallavendita.it</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E6E4E0]">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-5 text-xs text-[#5C5657] flex justify-between">
          <span>© {new Date().getFullYear()} RX CASA — Pronto alla Vendita</span>
          <span>Protocollo di verifica immobiliare</span>
        </div>
      </div>
      <div className="border-t border-[#E6E4E0]">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-4 text-xs text-[#8A8484] leading-relaxed text-center">
          Pronto alla Vendita è un marchio di RX CASA S.r.l. · P.IVA 04374880245 · N° REA VI-399432 · Viale del Mercato Nuovo 44/G, 36100 Vicenza (VI)
        </div>
      </div>
    </footer>
  );
}
